import LearningStyleQuiz from "../../learningStyleQuiz/learningStyleQuiz";
import Swotbutton from "../../../components/common/buttons/swotbutton";
import { useNavigate } from "react-router-dom";
import { useInView, animated, useSpring } from "@react-spring/web";

const PartSix = () => {
  const navigate = useNavigate();
  const itemSpring = useSpring({
    from: { y: 20, opacity: 0 },
    to: { y: 0, opacity: 1 },
  });

  const [ref, refSprings] = useInView(
    () => ({
      from: { y: 20, opacity: 0 },
      to: { y: 0, opacity: 1 },
    }),
    {
      root: null,
      rootMargin: "0px",
      once: true,
    }
  );

  const [cardContainerRef, cardContainerString] = useInView(
    () => ({
      from: { opacity: 0 },
      to: { opacity: 1 },
    }),
    {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
      once: true,
    }
  );
  return (
    <animated.div
      id={"unlock_potential"}
      className="bg-white text-center flex flex-col justify-between items-center mb-40 py-20"
      ref={ref}
      style={refSprings}
    >
      <p className="text-gray-600  text-3xl mt-2 lg:mt-8 w-full text-center pt-10 md:pt-0">
        Your Style
      </p>
      <animated.p
        className="text-gray-500 text-lg mt-2 lg:mt-8 w-10/12 lg:w-6/12 md:mb-14 mb-8 pt-10 md:pt-0"
        style={itemSpring}
      >
        <span className="text-[#9B3C66] font-semibold">Allow our AI</span> to
        uncover the most efficient and effective methods tailored for your
        learning and teaching.
        {/* <div className=" flex items-center justify-center my-5">
          <Swotbutton
            text={"Take Our Quiz"}
            onClick={() => navigate("/sign-in")}
          />
        </div> */}
      </animated.p>

      <animated.div
        ref={cardContainerRef}
        className="flex flex-col md:flex-row gap-20 md:gap-6 items-center mb-14 justify-around w-full p-2 md:px-4 lg:px-8 mt-8"
        style={cardContainerString}
      >
        <div>
          <LearningStyleQuiz></LearningStyleQuiz>
        </div>
      </animated.div>
    </animated.div>
  );
};

export default PartSix;